import React from "react";
import GATSBY_COMPILED_MDX from "/opt/build/repo/website/pages/docs/node-api.mdx";
var pageQuery = "1321869358";

function DocTemplate(_ref) {
  var children = _ref.children;
  return children;
}

DocTemplate;
export default function GatsbyMDXWrapper(props) {
  return /*#__PURE__*/React.createElement(DocTemplate, props, /*#__PURE__*/React.createElement(GATSBY_COMPILED_MDX, props));
}